import { useEffect, useCallback } from "react";
import { useDropzone } from "react-dropzone";
import close from "/assets/close.svg";
import upload from "/assets/upload.svg";

export default function DropZone({
  label,
  value,
  onChange,
  className,
}) {
  if (typeof onChange !== "function")
    console.debug("A drop zone doesn't have an onChange callback");

  const onDrop = useCallback(acceptedFiles => {
    const filePreviews = acceptedFiles.map(
      (file) => Object.assign(file, { previewURL: URL.createObjectURL(file) })
    );

    onChange(filePreviews[0]);
  }, [onChange]);

  const {
    getRootProps,
    getInputProps,
  } = useDropzone({ onDrop, multiple: false });

  const removeFile = (event) => {
    event.stopPropagation();
    onChange(null);
  };

  return (
    <div className="inpt-grp">
      {label && (
        <label className="lbl">{label}</label>
      )}
      <div {...getRootProps()} className={`inpt-dropzone ${className}`}>
        <input {...getInputProps()} />

        {(value.url || value.previewURL) ? (
          <>
            <img className="inpt-dropzone-preview-image" src={value.url || value.previewURL} />

            <button className="inpt-dropzone-remove" onClick={removeFile}>
              <img src={close} />
            </button>
          </>
        ) : (
          <div className="inpt-dropzone-placeholder">
            <img src={upload} />

            <div className="inpt-dropzone-placeholder-text-wrapper">
              <p className="inpt-dropzone-placeholder-text">Перетащите файл сюда</p>
              <p className="inpt-dropzone-placeholder-text">или</p>
              <p className="inpt-dropzone-placeholder-link">выберите файл</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
